import { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorStrings, fontFamilyHeading, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const accordion: RecursivePartial<{
    defaultProps?: AccordionPresentationProps | undefined;
    sectionDefaultProps?: AccordionSectionPresentationProps | undefined;
}> = {
    sectionDefaultProps: {
        mergeCss: true,
        headerProps: {
            css: css`
                dt button,
                button {
                    background-color: ${getColor(colorStrings.commonGlobalWhite)};
                    border-color: ${getColor(colorStrings.commonGlobalBlack)};
                    border-radius: 4px;
                    padding: 24px !important;

                    ${mediaQueriesBP.maxMD} {
                        padding: 16px !important;
                    }

                    span {
                        font-family: ${fontFamilyHeading};
                        font-size: 18px;
                        font-weight: 700;
                        color: ${getColor(colorStrings.primaryMain)};

                        ${mediaQueriesBP.maxMD} {
                            font-size: 16px;
                            line-height: 19px;
                        }
                    }

                    &[aria-expanded="true"] {
                        border-bottom-color: transparent;
                        border-radius: 4px 4px 0 0;

                        &:focus {
                            border: 1px solid ${getColor(colorStrings.commonGlobalBlack)} !important;
                            border-bottom-color: transparent !important;
                        }

                        &:focus-visible {
                            border: 2px solid ${getColor(colorStrings.commonGlobalBlack)} !important;
                            border-bottom-color: transparent !important;
                        }
                    }
                }

                &&&& {
                    button {
                        &:focus {
                            padding: 24px;
                            border: 1px solid ${getColor(colorStrings.commonGlobalBlack)} !important;
                            border-top: 1px solid ${getColor(colorStrings.commonGlobalBlack)} !important;

                            ${mediaQueriesBP.maxMD} {
                                padding: 16px;
                            }
                        }

                        &:focus-visible {
                            border: 2px solid ${getColor(colorStrings.commonGlobalBlack)} !important;
                        }

                        &[aria-expanded="true"] {
                            border-bottom-color: transparent;
                            border-radius: 4px 4px 0 0;

                            &:focus {
                                border: 1px solid ${getColor(colorStrings.commonGlobalBlack)} !important;
                                border-bottom-color: transparent !important;
                            }

                            &:focus-visible {
                                border: 1px solid ${getColor(colorStrings.commonGlobalBlack)} !important;
                                border-bottom-color: transparent !important;
                            }
                        }
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                margin-top: -1px;
                border-color: ${getColor(colorStrings.commonGlobalBlack)};
                padding: 0 24px 24px 24px;
                border-radius: 0 0 4px 4px;

                ${mediaQueriesBP.maxMD} {
                    padding: 0 16px 16px 16px;
                }

                p,
                li,
                a,
                span,
                em,
                strong {
                    font-size: 16px;
                    line-height: 29px;

                    ${mediaQueriesBP.maxMD} {
                        font-size: 14px;
                        line-height: 25px;
                    }
                }
            `,
        },
    },
};
